import React, { useState } from "react";
import { Link } from "react-router-dom";

const PageNotFound = () => {

    return (
        <div className="container">
            <div className="row">
                <div className="col-md-12 text-center">
                    <h1 className="display-1">404</h1>
                    <p className="display-3 mb-5">Page introuvable</p>
                    <Link to="/rapport/frontend/">Retourner à l'acceuil</Link>
                </div>
            </div>
        </div>
    );
};

export default PageNotFound;
